<template lang="pug" functional>
  .container
    .fixed-width-tweak-upper
      .row.xs-f-small.max-at-tweak
        .xs-12
          slot
  
</template>

<script>
  export default {
    name: "FixedWidthContainer"
   }
</script>
